<template>
  <div>
    <fullscreen ref="fullscreen" :fullscreen.sync="IsFullScreen">
      <b-row class="m-0">
        <!-- <b-col>
          </b-col> -->
        <b-col class="text-right">
          <downloadChart :commitName="'GDP & Treaury yield'" />
        </b-col>
      </b-row>
      <b-row class="m-0 chartTabPanel autoCursor scroll50Panel">
        <b-col ref="capture">
          <b-row>
            <b-col cols="6">
              <b-card class="mb-3">
                <template #header>
                  <b-row>
                    <b-col
                      ><h6 class="mb-0">Nominal GDP Less Fed Fund</h6></b-col
                    >
                  </b-row>
                </template>

                <Plotly
                  :data="nominalgdplessfedfundData"
                  :layout="lineBarlayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
            <b-col cols="6">
              <b-card class="mb-3">
                <template #header>
                  <b-row>
                    <b-col
                      ><h6 class="mb-0">
                        10 year treasury Less 3-Month Euro$
                      </h6></b-col
                    >
                  </b-row>
                </template>
                <Plotly
                  :data="year10treasuryless3montheuroData"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-card class="mb-3">
                <template #header>
                  <b-row>
                    <b-col cols="4" class="p-0 pl-2"
                      ><h6 class="mb-0">Key Bank Rates FEC ECB ETC</h6></b-col
                    >
                    <b-col cols="8">
                      <div class="float-right">
                        <div class="filterText">Filter by Year:</div>
                      </div>
                    </b-col>
                    <b-col cols="12" class="p-0">
                      <b-col class="float-right w-75 ">
                        <div class="d-flex">
                          <b class="mr-3">{{
                            GDPTreasurySliderMinMaxValue[0]
                          }}</b>
                          <b-form-slider
                            v-if="
                              GDPTreasurySliderValue &&
                                GDPTreasurySliderValue.length
                            "
                            class="w-100 p-0 pr-2"
                            ref="mySlider"
                            :value="GDPTreasurySliderValue"
                            :min="GDPTreasurySliderValue[0]"
                            :max="GDPTreasurySliderValue[1]"
                            :range="slider_range"
                            @slide-stop="
                              slideChange('GDPTreasuryDataValue', $event)
                            "
                          ></b-form-slider>
                          <b class="ml-3">{{
                            GDPTreasurySliderMinMaxValue[1]
                          }}</b>
                        </div>
                      </b-col>
                    </b-col>
                  </b-row>
                </template>
                <Plotly
                  :data="keybankratesfececbetcData"
                  :layout="Barlayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
            <b-col cols="6">
              <b-card class="mb-3">
                <template #header>
                  <b-row>
                    <b-col
                      ><h6 class="mb-0">
                        Key Bank Rates China & Brazil
                      </h6></b-col
                    >
                  </b-row>
                </template>
                <Plotly
                  :data="keybankrateschinabrazilData"
                  :layout="linelayout"
                  :display-mode-bar="false"
                  :config="config"
                  ref="plotlyChart"
                ></Plotly>
              </b-card>
            </b-col>
          </b-row> </b-col
      ></b-row>
    </fullscreen>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import bFormSlider from "vue-bootstrap-slider/es/form-slider";
import "bootstrap-slider/dist/css/bootstrap-slider.css";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "GDP_Treasury_yield",
  components: {
    Plotly,
    bFormSlider,
    downloadChart,
  },
  computed: {
    ...mapGetters({
      nominalgdplessfedfund: "nominalgdplessfedfund",
      year10treasuryless3montheuro: "year10treasuryless3montheuro",
      keybankratesfececbetc: "keybankratesfececbetc",
      keybankrateschinabrazil: "keybankrateschinabrazil",
      isFullScreen: "isFullScreen",
    }),
    nominalgdplessfedfundData() {
      let formattedData = this.nominalgdplessfedfundClone.map(function(i) {
        return {
          bar: +i.nominal_gdp,
          lineField1: +i.bank_tightening,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "%Bank tightening standards(RHS)",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "rgb(127, 127, 127)",
        },
      };

      let trace2 = {
        type: "bar",
        mode: "bar",
        name: "Nominal GDP less FFR (LHS)",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "bar"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        marker: {
          color: "rgb(31, 119, 180)",
        },
      };

      let data = [trace1, trace2];
      return data;
    },
    year10treasuryless3montheuroData() {
      let formattedData = this.year10treasuryless3montheuroClone.map(function(
        i
      ) {
        return {
          lineField: +i.year_treasury,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "Treasury",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#52bcd3",
        },
      };

      let data = [trace1];
      return data;
    },
    keybankratesfececbetcData() {
      let formattedData = this.keybankratesfececbetcClone.map(function(i) {
        return {
          lineField: +i.bank_canada,
          lineField1: +i.bank_england,
          lineField2: +i.ecb_rate,
          lineField3: +i.fed_rate,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "Canada",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: 'spline',
          smoothing: 1.3,
          color: "#52bcd3",
        },
      };

      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "England",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: 'spline',
          smoothing: 1.3,
          color: "#e9cd90",
        },
      };
      let trace3 = {
        type: "scatter",
        mode: "lines",
        name: "ECB",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField2"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: 'spline',
          smoothing: 1.3,
          color: "#ededed",
        },
      };
      let trace4 = {
        type: "scatter",
        mode: "lines",
        name: "FED",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField3"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          shape: 'spline',
          smoothing: 1.3,
          color: "#000",
        },
      };

      let consumersentimentData = [trace1, trace2, trace3, trace4];
      return consumersentimentData;
    },
    keybankrateschinabrazilData() {
      let formattedData = this.keybankrateschinabrazilClone.map(function(i) {
        return {
          lineField: +i.bank_of_brazil,
          lineField1: +i.china_benchmark,
          xField: i.date,
        };
      });
      let trace1 = {
        type: "scatter",
        mode: "lines",
        name: "Bank of Brazil target rate",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField1"),
        year: this.unpack(formattedData, "year"),
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "rgb(23, 190, 207)",
        },
      };

      let trace2 = {
        type: "scatter",
        mode: "lines",
        name: "china 1-yr benchmark lending rate",
        x: this.unpack(formattedData, "xField"),
        y: this.unpack(formattedData, "lineField"),
        year: trace1.year,
        xaxis: "x",
        yaxis: "y",
        line: {
          color: "#000",
        },
      };

      let consumersentimentData = [trace1, trace2];
      return consumersentimentData;
    },
  },
  data() {
    return {
      chartTitle: "",
      IsFullScreen: this.isFullScreen,
      linelayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 100,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        legend: {
          x: 0,
          y: -0.5,
          orientation: "h",
        },
      },
      lineBarlayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        legend: {
          x: 0,
          y: -0.5,
          orientation: "h",
        },
      },
      Barlayout: {
        width: "500",
        height: 350,
        autosize: true,
        margin: {
          l: "50",
          r: "30",
          b: 30,
          t: 30,
          pad: 0,
        },
        xaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          fixedrange: true,
          zeroline: false,
          ntick: "auto",
          ticks: "outside",
          showspikes: false,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          showline: true,
          zeroline: false,
          ticks: "outside",
          //ticksuffix:'mm',
          showzero: true,
          fixedrange: true,
          range: [0, 5],
          nticks: 8,
        },
        legend: {
          x: 0,
          y: -0.8,
          orientation: "h",
        },
      },
      config: { responsive: true },
      sliderValue: [2018, 2021],
      min: 2018,
      max: 2021,
      downloadImg: ["fa", "download"],
      zoomImg: ["fas", "expand"],
      zoomOutImg: ["fas", "compress"],
      fullscreen: false,
      nominalgdplessfedfundClone: this.nominalgdplessfedfund
        ? this.nominalgdplessfedfund
        : [],
      year10treasuryless3montheuroClone: this.year10treasuryless3montheuro
        ? this.year10treasuryless3montheuro
        : [],
      keybankratesfececbetcClone: this.keybankratesfececbetc
        ? this.keybankratesfececbetc
        : [],
      keybankrateschinabrazilClone: this.keybankrateschinabrazil
        ? this.keybankrateschinabrazil
        : [],
      slider_range: true,
      GDPTreasurySliderMinMaxValue: [],
      GDPTreasurySliderValue: [],
    };
  },
  created() {
    // console.log('this.$refs.capture-=-=-',this.$refs);
    this.setDownloadInfo({
      fileName: "CPI_and_Sentiment",
      downloadData: this.$refs.capture,
    });
  },
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "getIframeChartDataById",
    ]),
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    slideChange(e, $event) {
      var chartData = JSON.parse(JSON.stringify(this.keybankratesfececbetc));
      // let filterData = { x: [], y: [], measure: [], text: [] };
      let chartDataFilterArr = [];
      let yearArr = $event;
      this.GDPTreasurySliderMinMaxValue = yearArr;
      for (let i = 0; i < chartData.length; i++) {
        if (
          parseInt(chartData[i].year) >= parseInt(yearArr[0]) &&
          parseInt(chartData[i].year) <= parseInt(yearArr[1])
        ) {
          chartDataFilterArr.push(chartData[i]);
        }
      }
      this.keybankratesfececbetcClone = [];
      this.keybankratesfececbetcClone = chartDataFilterArr;
    },
    async chartData() {
      if (window.location.href.includes("auth_token=")) {
        let child = [
          {
            chartId: 71,
          },
          {
            chartId: 72,
          },
          {
            chartId: 73,
          },
          {
            chartId: 74,
          },
        ];
        for (let i = 0; i < child.length; i++) {
          let data = await this.getIframeChartDataById(child[i].chartId);
          if (child[i].chartId === 71) {
            this.nominalgdplessfedfundClone = data;
          } else if (child[i].chartId === 72) {
            this.year10treasuryless3montheuroClone = data;
          } else if (child[i].chartId === 73) {
            this.keybankratesfececbetcClone = data;
          } else if (child[i].chartId === 74) {
            this.keybankrateschinabrazilClone = data;
          }
        }
      }
    },
  },
  mounted() {
    this.setDownloadInfo({
      fileName: "GDP_Treasury_yield",
      downloadData: this.$refs.capture,
    });
    if (window.location.href.includes("auth_token=")) {
      this.chartData();
    }
  },
  watch: {
    nominalgdplessfedfund: {
      deep: true,
      handler() {
        if (this.nominalgdplessfedfund) {
          this.nominalgdplessfedfundClone = this.nominalgdplessfedfund;
        }
      },
    },
    year10treasuryless3montheuro: {
      deep: true,
      handler() {
        if (this.year10treasuryless3montheuro) {
          this.year10treasuryless3montheuroClone = this.year10treasuryless3montheuro;
        }
      },
    },
    keybankratesfececbetc: {
      deep: true,
      handler() {
        if (this.keybankratesfececbetc) {
          this.keybankratesfececbetcClone = this.keybankratesfececbetc;
          let yearArr = [];
          for (let i = 0; i < this.keybankratesfececbetcClone.length; i++) {
            let year = this.keybankratesfececbetcClone[i].year;
            yearArr.push(year);
          }
          if (yearArr && yearArr.length) {
            yearArr = yearArr.sort();
            let minMax = [yearArr[0], yearArr[yearArr.length - 1]];
            this.GDPTreasurySliderMinMaxValue = minMax;
            this.GDPTreasurySliderValue = minMax;
          }
        }
      },
    },
    keybankrateschinabrazil: {
      deep: true,
      handler() {
        if (this.keybankrateschinabrazil) {
          this.keybankrateschinabrazilClone = this.keybankrateschinabrazil;
        }
      },
    },
  },
};
</script>

<style lang="scss">
.salesContainer {
  position: relative;
}
.card-header .slider.slider-horizontal {
  width: 100% !important;
  height: 20px;
}
.scroll50Panel {
  height: 50vh;
  padding-bottom: 50px;
  overflow: auto;
}
.fullscreen .scroll50Panel {
  height: auto;
}
</style>
